[
  {
    "filename": "202508172020_lz2mh.mp4",
    "title": "Avoiding or trying to supress your thoughts ... only causes them to increase.",
    "duration": "0:00:8",
    "description": "male_costume0_cameraA"
  },
  {
    "filename": "202508172047_8mh6f.mp4",
    "title": "Understanding non-self is understanding the root of suffering ... suffering mostly comes from clinging to the things we call 'mine'.",
    "duration": "0:00:8",
    "description": "female_costume0_cameraA"
  },
  {
    "filename": "202508172053_p2c2z.mp4",
    "title": "Thoughts and emotions change ... but the awareness that observes them is always present.",
    "duration": "0:00:8",
    "description": "female_costume0_cameraA"
  }
]
